<template>
  <div class="contenido bg-primary">
    <div class="pt-16 py-6 mx-auto max-w-md block justify-center">
      <div class="text-center w-full">
        <h1 class="font-light text-white">ENTRENAMIENTO POR OBJETIVOS</h1>
      </div>
      <div
        class="mx-auto text-white text-center my-4"
      >Según tus objetivos creamos un entrenamiento para optimizar tu tiempo y duplicar tus resultados.</div>
      <div
        class="text-white text-center"
      >Selecciona tu rutina para conocer los objetivos y ¡empieza a cumplirlos!.</div>

      <!-- Dias -->
      <div class="block justify-center">
        <!-- <div class="my-4" v-for="(d,i) in objetivos" :key="i">
          <div class="cursor-pointer mx-auto bg-yellow dia text-center">
            <span class="text-center">{{ d.nombre }}</span>
          </div>
        </div>-->
        <!-- 1 -->
        <div class="my-4">
          <div @click="selectObjetivo(1)" class="cursor-pointer mx-auto max-w-xs">
            <img class src="../assets/1.png" alt="Adelgazar">
          </div>
        </div>
        <!-- 2 -->
        <div class="my-4">
          <div @click="selectObjetivo(2)" class="cursor-pointer mx-auto max-w-xs">
            <img class src="../assets/2.png" alt="Adelgazar">
          </div>
        </div>
        <!-- 3 -->
        <div class="my-4">
          <div @click="selectObjetivo(3)" class="cursor-pointer mx-auto max-w-xs">
            <img class src="../assets/3.png" alt="Adelgazar">
          </div>
        </div>
        <!-- 4 -->
        <div class="my-4">
          <div @click="selectObjetivo(4)" class="cursor-pointer mx-auto max-w-xs">
            <img class src="../assets/4.png" alt="Adelgazar">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objetivos: {
      required: true
    }
  },
  methods: {
      selectObjetivo(o) {
          this.$emit('objetivo',o);
      }
  }
};
</script>

<style lang="scss" scoped>
.contenido {
  min-height: calc(100vh - 70px);
  margin-top: 70px;
}
</style>
